// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "modules/" + chunkId + "-b1-" + {"481":"189edc64d8cc891d418e","620":"a213a8a3ba54f7637db6","639":"ee5c1635363fbc35f5ff","881":"7530f957f15ac658d042","911":"e87f0840b6f72d22f28a","966":"b7f8b118ef4ddf458396"}[chunkId] + ".js";
};